export let OfertasComponent = {
    selector: 'editarOfertas',
    template: require('./ofertas.html'),
    bindings: {
        ofertas: '<',
        categorias: '<'
    },
    controller: class {

        /*@ngInject*/
        constructor(UTIL_URL, Upload, ConfiguracionService, $route, ToasterService) {
            Object.assign(this, {UTIL_URL, Upload, ConfiguracionService, $route, ToasterService});
            this.subiendoArchivo = false;
        }

        $onInit() {
            (this.ofertas || []).forEach(oferta => {
                oferta.categoria = oferta.categoria || null;
                oferta.subcategoria = oferta.subcategoria || null;
            });
        }

        uploadFiles(file, err) {
            if (err.length === 0)
                this.file = file;
        }

        subirOferta() {

            if (this.file) {
                if (this.categoriaSeleccionada) {

                    this.subiendoArchivo = true;
                    this.Upload.upload({
                            url: `${this.UTIL_URL}/ofertas/upload`,
                            data: {
                                categoria: this.categoriaSeleccionada.categoria,
                                subcategoria: (this.subcategoriaSeleccionada ? this.subcategoriaSeleccionada.subcategoria : ''),
                                file: this.file
                            }
                        })
                        .then((res) => {
                            this.ToasterService.popUp('success','Oferta', 'Se ha creado con éxito.');
                            this.$route.reload();
                        })
                } else {
                    this.ToasterService.popUp('info','Informacion', 'Seleccione una categoría.');
                }
            } else {
                this.ToasterService.popUp('info','Informacion', 'Seleccione una imagen.');
            }
        }

        subcategoriasDe(nombreCategoria) {
            const categoria = (this.categorias || []).find(item => item.categoria === nombreCategoria);
            return categoria ? categoria.subcategorias : [];
        }

        cambiarCategoriaOferta(oferta) {
            oferta.subcategoria = null;
        }

        guardarDestinoOferta(oferta) {
            if (!oferta.categoria) {
                this.ToasterService.popUp('info','Informacion', 'Seleccione una categoría.');
                return;
            }
            this.ConfiguracionService.actualizarOferta(oferta._id, {
                    categoria: oferta.categoria,
                    subcategoria: oferta.subcategoria || ''
                })
                .then(data => {
                    this.ToasterService.popUp('success','Oferta', 'Se ha actualizado el destino.');
                })
        }

        borrarOferta(id) {
            this.ConfiguracionService.borrarOferta(id)
                .then(data => {
                    this.ToasterService.popUp('success','Oferta', 'Se ha eliminado con éxito.');
                    this.$route.reload();
                })
        }


    }
};


// WEBPACK FOOTER //
// ./client/app/configuracion-route/ofertas/ofertas.component.js